import { Injectable } from '@angular/core';
import { ProductsBaseService } from '../products-base.service';
import { ProductsTransformService } from '../products-transform.service';

@Injectable({
  providedIn: 'root'
})
export class GetCreditPaymentScheduleCommand {
  constructor(
    private productsBase: ProductsBaseService,
    private productsTransform: ProductsTransformService
  ) {}

  execute(id: string) {
    const product = this.productsBase.findProductById(this.productsBase.products, id);
    const subtitle = this.productsTransform.getProductInfo(product, product.productType);

    return {
      title: 'График платежей',
      subtitle,
      id,
      scheduleMode: true
    };
  }
}
